/* SAYAB — Shop the Look (custom element) */
class SayabShopLook extends HTMLElement {
  constructor() {
    super();
    this.looks = [];
    this.current = 0;
  }

  connectedCallback() {
    this.looks = Array.from(this.querySelectorAll('.sayab-shop-look__look'));
    if (!this.looks.length) return;

    this.dots = Array.from(this.querySelectorAll('[data-look-dot]'));
    this.prevBtn = this.querySelector('[data-look-prev]');
    this.nextBtn = this.querySelector('[data-look-next]');

    this.looks.forEach((look) => this.bindHotspots(look));

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.getAttribute('data-look-dot'), 10);
        this.go(idx);
      });
    });
  }

  bindHotspots(look) {
    const hotspots = look.querySelectorAll('.sayab-shop-look__hotspot');
    const card = look.querySelector('[data-product-card]');
    if (!card) return;

    const titleEl = card.querySelector('[data-product-title]');
    const priceEl = card.querySelector('[data-product-price]');
    const imgEl = card.querySelector('[data-product-image]');
    const imgLink = card.querySelector('[data-product-image-link]');
    const linkEl = card.querySelector('[data-product-link]');

    const defaultData = {
      title: titleEl ? titleEl.textContent : '',
      price: priceEl ? priceEl.textContent : '',
      image: imgEl ? imgEl.getAttribute('src') : '',
      url: linkEl ? linkEl.getAttribute('href') : '',
    };

    hotspots.forEach((hp) => {
      hp.addEventListener('click', () => {
        hotspots.forEach((other) => other.classList.remove('is-active'));
        hp.classList.add('is-active');

        const data = {
          title: hp.getAttribute('data-product-title'),
          price: hp.getAttribute('data-product-price'),
          image: hp.getAttribute('data-product-image'),
          url: hp.getAttribute('data-product-url'),
        };

        if (titleEl) titleEl.textContent = data.title;
        if (priceEl) priceEl.innerHTML = data.price;
        if (imgEl) {
          imgEl.style.opacity = '0';
          setTimeout(() => {
            imgEl.setAttribute('src', data.image);
            imgEl.setAttribute('alt', data.title);
            imgEl.style.opacity = '1';
          }, 150);
          imgEl.style.transition = 'opacity 0.25s ease';
        }
        if (imgLink) imgLink.setAttribute('href', data.url);
        if (linkEl) linkEl.setAttribute('href', data.url);
      });

      if (hp.getAttribute('data-default') === 'true') {
        hp.classList.add('is-active');
      }
    });
  }

  go(idx) {
    const total = this.looks.length;
    if (total === 0) return;
    const next = ((idx % total) + total) % total;
    this.looks[this.current].classList.remove('is-active');
    this.looks[next].classList.add('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');
    if (this.dots[next]) this.dots[next].classList.add('is-active');
    this.current = next;
  }
}

if (!customElements.get('sayab-shop-look')) {
  customElements.define('sayab-shop-look', SayabShopLook);
}
